import { useEffect, useState } from "react";
import { Document } from "@contentful/rich-text-types";
import { CallState } from "@hopper-b2b/types";

// hack to trick editor to show graphql syntax highlighting
const gql = String.raw;

export interface PrivacyPolicyContent {
  headline: string;
  content1: {
    json: Document;
  };
}

export function useFetchPrivacy(): {
  data: PrivacyPolicyContent;
  status: CallState;
} {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState<CallState>(CallState.InProcess);

  useEffect(() => {
    const abort = new AbortController();
    (async () => {
      const response = await fetch("https://hopper.com/api/v1/contentful", {
        signal: abort.signal,
        body: JSON.stringify({
          space: "legal",
          query: gql`
            query {
              pageCollection(
                limit: 1
                where: { slug_contains: "privacy-policy", locale: "en" }
              ) {
                items {
                  headline
                  content1 {
                    json
                  }
                }
              }
            }
          `,
        }),
        method: "PUT",
        mode: "cors",
      });

      if (response.ok) {
        const data = await response.json();
        setStatus(CallState.Success);
        setData(data?.data?.pageCollection?.items[0]);
      } else {
        setStatus(CallState.Failed);
      }
    })();

    return () => {
      abort.abort();
    };
  }, []);

  return { data, status };
}
